module.exports = __webpack_public_path__ + "static/media/event.349aa913.svg";